import React, { Component } from "react";
import LinearProgress from "../components/LinearProgress";
import { connect } from "react-redux";
import Paper from "material-ui/Paper";
import { RaisedButton, Snackbar } from "material-ui";
import firebase from "../firebase";
import { injectStripe } from "react-stripe-elements";
import StripeElements from "../components/StripeElements";
import PaymentPlanCard from "../components/PaymentPlanCard";

const styles = {
  root: {
    padding: 20,
    margin: "0 auto",
  },
  form: {},
  toggleStyle: {
    marginTop: 10,
    marginBottom: 10,
  },
  paper: {
    padding: 20,
  },
  gridList: {
    width: "100%",
    height: "100%",
    overflowY: "auto",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
  },
  saveButton: {
    marginTop: 15,
  },
};

const features = [
  "Interactive menu QR code",
  "Real time menu updates",
  "Native Android and iOS apps",
  "Unlimited Users",
  "Unlimited Menu",
  "Unlimited Deals",
  "Push Notifications",
  "Online Ordering",
  "Social Media Links",
  "Analytics",
  "$0 Setup Fee",
];

const liteFeatures = [
  "Interactive menu QR code",
  "Real time menu updates",
  "Menu customization",
  "Unlimited Users",
  "Unlimited Menu",
  "Unlimited Deals",
  "Works in any mobile browser",
  "Start using it instantly",
  "Social Media Links",
  "Analytics",
  "$0 Setup Fee",
];

class Subscribe extends Component {
  state = {
    submitting: false,
    loading: false,
    snackbarOpen: false,
    snackbarMessage: "",
    paymentGroups: {
      general: [
        {
          id: "price_1HXE4fB43t3dQ0bOGc4V9Bx1",
          name: "Lite",
          price: 9.99,
          features: liteFeatures,
        },
        {
          id: "price_1GvTkEB43t3dQ0bOIGdZt9Ti",
          name: "Monthly",
          price: 19.99,
          features,
        },
        {
          id: "price_1GvTkcB43t3dQ0bOyUzQppAH",
          name: "Yearly",
          price: 199,
          features,
        },
      ],
    },
  };

  async componentDidMount() {}

  handleCloseSnackbar = () => {
    this.setState({
      snackbarOpen: false,
    });
  };

  handleError = (e) => {
    this.setState({
      loading: false,
      submitting: false,
      snackbarMessage: e.message,
      snackbarOpen: true,
    });
  };

  handlePayment = (planId) => {
    this.setState({
      submitting: true,
    });

    firebase
      .functions()
      .httpsCallable("createCheckoutSession")({
        planId,
        successUrl: "https://dashboard.chowreach.com",
        cancelUrl: "https://dashboard.chowreach.com",
      })
      .then((response) => {
        try {
          this.props.stripe
            .redirectToCheckout({
              sessionId: response.data.id,
            })
            .then(function (result) {
              if (result.error) {
                // If `redirectToCheckout` fails due to a browser or network
                // error, display the localized error message to your customer.
                this.handleError(result.error);
              }
            });
        } catch (e) {
          this.handleError(e);
        }
      })
      .catch((error) => {
        this.handleError(error);
      });
  };

  renderPaymentPlans() {
    return this.state.paymentGroups[
      this.props.group
    ].map(({ id, name, price, features }) => (
      <PaymentPlanCard
        key={id}
        id={id}
        name={name}
        price={price}
        features={features}
        buttonLabel={this.state.submitting ? "Loading..." : "Subscribe"}
        onTouchTap={() => this.handlePayment(id)}
        buttonDisabled={this.state.submitting}
      />
    ));
  }

  render() {
    const { loading, submitting } = this.state;

    if (loading) return <LinearProgress />;

    return (
      <div style={styles.root}>
        <h1>Chowreach Subscription</h1>
        <form style={styles.form}>
          <Paper style={{ padding: 20, marginTop: 20 }}>
            <div style={styles.gridList}>{this.renderPaymentPlans()}</div>
          </Paper>
          <Snackbar
            open={this.state.snackbarOpen}
            message={this.state.snackbarMessage}
            autoHideDuration={4000}
            onRequestClose={this.handleCloseSnackbar}
          />
        </form>
      </div>
    );
  }
}

function mapDispatchToProps(state) {
  return {
    group: state.app.group,
  };
}

export default connect(mapDispatchToProps)(
  StripeElements(injectStripe(Subscribe))
);



// WEBPACK FOOTER //
// ./src/pages/Subscribe.js